import React, { Component } from 'react';
import { Button, Chip, Grid, IconButton, TableBody, TableCell, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import PgmVodDialog from '../components/dialogs/PgmVodDialog';
import { CHANNEL, CHANNEL_DP, EVENT_ID, FACULTY_API_URL, groupBy } from '../constants';
import FacultyDetail from '../faculty/FacultyDetail';

import { BsClock } from 'react-icons/bs';

import axios from 'axios';

const styles = (theme) => ({
  dialogRoot: {
    minHeight: '80vh',
    maxHeight: '92vh',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100vh',
      margin: '0px',
    },
  },
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
    fontSize: '20px',
    color: theme.palette.primary.main,
    textAlign: 'center',
    borderBottom: '2px solid #025a3c',
  },
  dialogTitleContent: {
    fontWeight: 'bold',
    margin: '0 15px',
    paddingTop: '1em',
    // paddingBottom: '1.5em',
    [theme.breakpoints.down('sm')]: {
      // padding: '0.6em',
      padding: 0,
      fontSize: '16px',
    },
  },
  dialogContent: {
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px',
    },
  },
  dialogActions: {
    borderTop: '1px solid #ebebeb',
    margin: '0 24px',
    textAlign: 'center',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  tableHead: {
    background: '#f3f3f3',
    width: '160px',
    borderTop: '1px solid #e0e0e0',
    borderLeftWidth: '0px',
    borderRightWidth: '0px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContent: {
    borderLeftWidth: '0px',
    borderRightWidth: '0px',
    width: '20%',
    marginRight: '2px',
  },
  closeButton: {
    position: 'absolute',
    // right: theme.spacing(1),
    // top: theme.spacing(1),
    right: 0,
    top: 0,
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  cell2: {
    borderBottom: 0,
  },

  table_Web: {
    display: 'none',
    [theme.breakpoints.up('xs')]: {
      display: 'block',
    },
  },
  table_mob: {
    display: 'none',

    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
});

// const StyledTableCell = withStyles((theme) => ({
//   body: {
//     fontWeight: 'bold',
//     backgroundColor: '#dedee6',
//   },
// }))(TableCell);
// const StyledTableCell2 = withStyles((theme) => ({
//   body: {
//     wordBreak: 'keep-word',
//   },
// }))(TableCell);

class ProgramDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pgmVodDialog: false,
      vodId: '',
      matches: window.matchMedia('(max-width:960px)').matches,
    };

    this.closeFacultyDialog = this.closeFacultyDialog.bind(this);
  }

  componentDidMount() {}
  clickVOD = (e, vod) => {
    e.stopPropagation();
    this.setState({ vodId: vod, pgmVodDialog: true });
  };

  closeFacultyDialog() {
    this.setState({ isFacultyDialogOpen: false });
  }

  goFaculty = (data) => {
    // console.log(data);
    if (data) {
      axios
        .get(`${FACULTY_API_URL}/faculty/info?eventId=${EVENT_ID}&id=${EVENT_ID}_${data.presenterEmail}`)
        // .get(`${FACULTY_API_URL}/faculty/info?eventId=${EVENT_ID}&id=${EVENT_ID}_test82@test.com`)
        .then((response) => {
          // console.log('Faculty::', response.data.Item);
          if (response.data && response.data.Item) {
            this.setState({ facultyInfo: response.data.Item, isFacultyDialogOpen: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  renderChairmanRow = () => {
    return this.state.matches ? (
      <>
        <TableRow>
          <TableCell style={{ minWidth: '100px', backgroundColor: 'rgba(8,216,160,0.5)', fontWeight: 'bold' }}>
            {'Chairperson(s)'}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={2}>{this.renderChairman()}</TableCell>
        </TableRow>
      </>
    ) : (
      <TableRow>
        <TableCell style={{ minWidth: '100px', fontWeight: 'bold' }}>{'Chairperson(s)'}</TableCell>
        <TableCell colSpan={2}>{this.renderChairman()}</TableCell>
      </TableRow>
    );
  };

  renderChairman = () => {
    const p = groupBy(this.props.data, 'title');

    return (
      this.props.data &&
      this.props.data.length > 0 &&
      // p['Chairperson(s)'].map((c, idx) => {
      //   const comma = idx < p['Chairperson(s)'].length - 1 ? ', ' : '';

      p['Chairperson']
        .sort(function (a, b) {
          return a.order > b.order ? 1 : -1;
        })
        .map((c, idx) => {
          // console.log('cccccc', c);
          const comma = idx < p['Chairperson'].length - 1 ? ', ' : '';
          return (
            <div
              key={'chairman-' + idx}
              style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => this.goFaculty(c)}
            >
              {this.props.selData.isEng === true ? <>{c.nameEng + comma}</> : <>{c.nameKor + comma}</>}
              {/* {c.nameKor + comma} */}
            </div>
          );
        })
    );
  };

  renderChairmanMob = () => {
    const p = groupBy(this.props.data, 'title');
    return (
      this.props.data.length > 0 &&
      // p['Chairperson(s)'].map((c, idx) => {
      //   const comma = idx < p['Chairperson(s)'].length - 1 ? ', ' : '';
      p['Chairperson']
        .sort(function (a, b) {
          return a.order > b.order ? 1 : -1;
        })
        .map((c, idx) => {
          const comma = idx < p['Chairperson'].length - 1 ? ', ' : '';
          return (
            <span
              key={'chairman-' + idx}
              style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => this.goFaculty(c)}
            >
              {this.props.selData.isEng === true ? <>{c.nameEng + comma}</> : <>{c.nameKor + comma}</>}
              {/* {c.presenter + comma} */}
            </span>
          );
        })
    );
  };

  renderPanel = () => {
    const p = groupBy(this.props.data, 'title');
    const dp = p['Panel'];
    return this.state.matches ? (
      <>
        <TableRow key={'panels_a'} style={!dp ? { display: 'none' } : { display: 'table-row' }}>
          <TableCell style={{ minWidth: '100px', backgroundColor: 'rgba(8,216,160,0.5)', fontWeight: 'bold' }}>{'Panel'}</TableCell>
        </TableRow>
        <TableRow key={'panels_b'} style={!dp ? { display: 'none' } : { display: 'table-row' }}>
          <TableCell colSpan={2}>
            {/*<div>*/}
            {this.props.data.length > 0 &&
              p['Panel'] &&
              p['Panel']
                .sort(function (a, b) {
                  return a.order > b.order ? 1 : -1;
                })
                .map((c, idx) => {
                  const comma = idx < p['Panel'].length - 1 ? ', ' : '';
                  return (
                    <div
                      key={'panel-' + idx}
                      style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => this.goFaculty(c)}
                    >
                      {this.props.selData.isEng === true ? <>{c.nameEng + comma}</> : <>{c.nameKor + comma}</>}
                      {/* {c.nameEng + comma} */}
                    </div>
                  );
                })}
            {/*</div>*/}
          </TableCell>
        </TableRow>
      </>
    ) : (
      <TableRow key={'panels'} style={!dp ? { display: 'none' } : { display: 'table-row' }}>
        <TableCell style={{ minWidth: '100px', fontWeight: 'bold' }}>{'Panel'}</TableCell>
        <TableCell colSpan={2}>
          {/*<div>*/}
          {this.props.data.length > 0 &&
            p['Panel'] &&
            p['Panel']
              .sort(function (a, b) {
                return a.order > b.order ? 1 : -1;
              })
              .map((c, idx) => {
                const comma = idx < p['Panel'].length - 1 ? ', ' : '';
                return (
                  <div
                    key={'panel-' + idx}
                    style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => this.goFaculty(c)}
                  >
                    {/* {c.nameKor + comma} */}
                    {this.props.selData.isEng === true ? <>{c.nameEng + comma}</> : <>{c.nameKor + comma}</>}
                  </div>
                );
              })}
          {/*</div>*/}
        </TableCell>
      </TableRow>
    );
  };
  renderExam = () => {
    const p = groupBy(this.props.data, 'title');
    const dp = p['Examiner'];
    return (
      <TableRow key={'Examiner'} style={!dp ? { display: 'none' } : { display: 'table-row' }}>
        <TableCell style={{ minWidth: '100px' }}>{'Examiner'}</TableCell>
        <TableCell colSpan={2}>
          {/*<div>*/}
          {this.props.data.length > 0 &&
            p['Examiner'] &&
            p['Examiner'].map((c, idx) => {
              const comma = idx < p['Examiner'].length - 1 ? ', ' : '';
              return (
                <div
                  key={'Examiner-' + idx}
                  style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => this.goFaculty(c)}
                >
                  {c.nameKor + comma}
                </div>
              );
            })}
          {/*</div>*/}
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { classes, open, onClose } = this.props;
    // console.log(this.props.data);
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          onClose={onClose}
          aria-labelledby="welcome-msg-dialog"
          open={open}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogTitle className={classes.dialogTitle} onClose={onClose}>
            {this.props.selData ? (
              <>
                {/* <div className={classes.dialogTitleContent}>
                  [&nbsp;{`${CHANNEL_DP[CHANNEL.indexOf(this.props.selData.ch)]}`}&nbsp;]
                  <br />
                  {this.props.selData.pgTitle}
                  {this.props.selData.pgSub}
                  <h3>{this.props.selData.dpTime}</h3>
                </div> */}
                <Grid container style={{ padding: this.state.matches ? this.props.theme.spacing(1) : this.props.theme.spacing(3) }}>
                  <Grid container>
                    <Grid>[&nbsp;{`${CHANNEL_DP[CHANNEL.indexOf(this.props.selData.ch)]}`}&nbsp;]</Grid>
                    <Grid>
                      {this.props.selData && this.props.selData.isEng === true && (
                        <Chip
                          label="Eng"
                          style={{
                            marginLeft: '10px',
                            color: '#fff',
                            backgroundColor: '#164578',
                            fontWeight: 'bold',
                            textTransform: 'none',
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid container justifyContent={this.state.matches ? 'center' : 'space-between'}>
                    <Grid container justifyContent="flex-start">
                      {this.props.selData.pgTitle}
                    </Grid>
                    <Grid container justifyContent="flex-end" style={{ fontSize: this.state.matches ? '15px' : '' }}>
                      {this.props.selData.dpTime}
                    </Grid>
                  </Grid>
                  <Grid container style={{ color: '#000000', fontSize: this.state.matches ? '18px' : '', textAlign: 'left' }}>
                    {this.props.selData.pgSub}
                  </Grid>
                </Grid>
              </>
            ) : (
              ''
            )}
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Table size="small" className={classes.table}>
              <TableBody>
                {this.renderChairmanRow()}
                {this.renderPanel()}
                {this.renderExam()}
                {/* eslint-disable-next-line */}
                {this.props.data.map((d, idx) => {
                  // const speaker = d.title !== 'Chairperson(s)' && d.title !== 'Panel' ? d.presenter : '';
                  const speaker =
                    d.title !== 'Chairperson' && d.title !== 'Panel' ? (this.props.selData.isEng === true ? d.nameEng : d.nameKor) : '';
                  // const pos = d.title !== 'Chairperson(s)' && d.title !== 'Panel' ? d.presenterPos : '';
                  if (d.title !== 'Chairperson' && d.title !== 'Panel' && d.title !== 'Examiner') {
                    return this.state.matches ? (
                      <>
                        <TableRow key={idx}>
                          <TableCell style={{ minWidth: '100px', backgroundColor: 'rgba(8,216,160,0.5)' }}>
                            <BsClock size={15} style={{ marginRight: '5px' }} />
                            {d.title}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={2}>
                            <div dangerouslySetInnerHTML={{ __html: d.contents }} style={{ fontWeight: 'bold' }} />
                            <span
                              onClick={() => this.goFaculty(d)}
                              dangerouslySetInnerHTML={{ __html: speaker }}
                              style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            />
                            <br />
                            <Grid container justifyContent="flex-start" item xs={12} style={{ fontSize: 'small', paddingTop: '5px' }}>
                              {this.props.selData.isEng === true ? (
                                <>
                                  {d.posEng && <span>{d.posEng}</span>}
                                  {d.country && d.posEng && d.country !== '.' && <span>,</span>}
                                  {d.country && <span>&nbsp;&nbsp;{d.country}</span>}
                                  {!d.country && d.posEng && <span>,&nbsp;Korea</span>}
                                </>
                              ) : (
                                <>
                                  {!d.country && d.posKor && <span>{d.posKor}</span>}
                                  {d.country && d.posEng && <span>{d.posEng}</span>}
                                  {d.country && d.posEng && <span>,</span>}
                                  {d.country && <span>&nbsp;&nbsp;{d.country}</span>}
                                </>
                              )}
                            </Grid>
                            {/* &nbsp; {pos && pos.length > 1 && <span dangerouslySetInnerHTML={{ __html: '(' + pos + ')' }} />} */}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          {d.pgVod && d.pgVod.length > 3 ? (
                            <TableCell>
                              <Chip
                                size="small"
                                label="VOD"
                                style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '2px' }}
                                onClick={(e) => {
                                  this.clickVOD(e, d.pgVod);
                                }}
                              />
                            </TableCell>
                          ) : null}

                          {/*<TableCell style={{ minWidth: '180px' }}>*/}
                          {/*  <div dangerouslySetInnerHTML={{ __html: d.presenter }} />*/}
                          {/*</TableCell>*/}
                          {/*<TableCell style={{ minWidth: '180px' }}>*/}
                          {/*  <div dangerouslySetInnerHTML={{ __html: d.presenterPos }} />*/}
                          {/*</TableCell>*/}
                        </TableRow>
                      </>
                    ) : (
                      <TableRow key={idx}>
                        <TableCell style={{ minWidth: '100px' }}>{d.title}</TableCell>
                        <TableCell>
                          <div dangerouslySetInnerHTML={{ __html: d.contents }} style={{ fontWeight: 'bold' }} />
                          <div
                            onClick={() => this.goFaculty(d)}
                            dangerouslySetInnerHTML={{ __html: speaker }}
                            style={{ float: 'right', textDecoration: 'underline', cursor: 'pointer' }}
                          />
                          <br />
                          <Grid container justifyContent="flex-end" item xs={12}>
                            {this.props.selData.isEng === true ? (
                              <>
                                {d.posEng && <span>{d.posEng}</span>}
                                {d.country && d.posEng && d.country !== '.' && <span>,</span>}
                                {d.country && <span>&nbsp;&nbsp;{d.country}</span>}
                                {!d.country && d.posEng && <span>,&nbsp;Korea</span>}
                              </>
                            ) : (
                              <>
                                {!d.country && d.posKor && <span>{d.posKor}</span>}
                                {d.country && d.posEng && <span>{d.posEng}</span>}
                                {d.country && d.posEng && <span>,</span>}
                                {d.country && <span>&nbsp;&nbsp;{d.country}</span>}
                              </>
                            )}
                          </Grid>
                          {/* <div dangerouslySetInnerHTML={{ __html: pos }} style={{ float: 'right' }} /> */}
                        </TableCell>
                        <TableCell>
                          {d.pgVod && d.pgVod.length > 3 ? (
                            <Chip
                              size="small"
                              label="VOD"
                              style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '2px' }}
                              onClick={(e) => {
                                this.clickVOD(e, d.pgVod);
                              }}
                            />
                          ) : null}
                        </TableCell>
                        {/*<TableCell style={{ minWidth: '180px' }}>*/}
                        {/*  <div dangerouslySetInnerHTML={{ __html: d.presenter }} />*/}
                        {/*</TableCell>*/}
                        {/*<TableCell style={{ minWidth: '180px' }}>*/}
                        {/*  <div dangerouslySetInnerHTML={{ __html: d.presenterPos }} />*/}
                        {/*</TableCell>*/}
                      </TableRow>
                    );
                  }
                })}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={onClose} style={{ color: '#000000', fontSize: 'large' }}>
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Faculty Dialog */}
        <FacultyDetail
          open={this.state.isFacultyDialogOpen}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.closeFacultyDialog();
            }
          }}
          // onClose={this.closeFacultyDialog.bind(this)}
          // disableBackdrop={false}
          selectedData={this.state.facultyInfo}
        />

        <PgmVodDialog
          open={this.state.pgmVodDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ pgmVodDialog: false });
            }
          }}
          // onClose={() => this.setState({ pgmVodDialog: false })}
          // disableBackdrop={false}
          vodId={this.state.vodId}
        />
      </div>
    );
  }
}
export default withStyles(styles, { withTheme: true })(ProgramDialog);
